import(/* webpackMode: "eager" */ "/vercel/path0/autogpt_platform/frontend/src/app/(platform)/artifacts/page.tsx");
